import { useRouteMatch, Route, useParams } from 'react-router-dom'
import DeveloperTiles from './control/DeveloperTiles'
import ContentModels from './control/contentModel/ContentModels'
import EditContentModel from './control/contentModel/EditContentModel'
import EditContentSetting from './control/contentModel/EditContentSetting'
import Profiles from './control/profiles/Profiles'
import EditProfile from './control/profiles/EditProfile'

const Control = ({language,setBreadcrumbObject}) => {
    let { url } = useRouteMatch();
    let { contentModelId, contentSettingId } = useParams();
    return (
        <div id="cc_content" className="scrollable">
            <Route path={url} exact strict>
                <DeveloperTiles language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
            <Route path={`${url}/contentModels`} exact strict>
                <ContentModels language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
            <Route path={`${url}/contentModels/:contentModelId`} exact strict>
                <EditContentModel contentModelId={contentModelId} language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
            <Route path={`${url}/contentModels/:contentModelId/setting/:settingId`} exact strict>
                <EditContentSetting contentModelId={contentModelId} contentSettingId={contentSettingId} language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
            <Route path={`${url}/profiles`} exact strict>
                <Profiles language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
            <Route path={`${url}/profiles/:profileId`} exact strict>
                <EditProfile language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route>
        </div>
    )
}

export default Control
